var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 36,
    viewBox: "0 0 210 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.442 0.5L85.0158 35.5H90.9411L107.907 6.72789L125.095 35.5H130.946L110.521 0.5H105.442Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.779 0.5H134.59V35.5H168.67V30.7289H139.779V0.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.227 0.5H210V5.45317H179.122V30.7289H210V35.5H174.227V0.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3607 8.6543V13.065H82.6604V6.69523C82.6604 3.2737 79.8867 0.5 76.4651 0.5H48.7399C45.3184 0.5 42.5447 3.2737 42.5447 6.69523V29.3048C42.5447 32.7263 45.3184 35.5 48.7399 35.5H76.4651C79.8867 35.5 82.6604 32.7263 82.6604 29.3048V22.8985H77.3607V27.6735C77.3607 29.4012 75.9601 30.8018 74.2324 30.8018H50.6414C48.9137 30.8018 47.5131 29.4012 47.5131 27.6735V8.6543C47.5131 6.9266 48.9137 5.52601 50.6414 5.52601H74.2324C75.9601 5.52601 77.3607 6.9266 77.3607 8.6543Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8349 7.73421V9.86004H37.5026V6.0205C37.5026 2.97161 35.031 0.5 31.9821 0.5H5.39783C2.41669 0.5 0 2.9167 0 5.89783V14.6235C0 17.6046 2.41669 20.0213 5.39783 20.0213H29.5654C30.8188 20.0213 31.8349 21.0374 31.8349 22.2909V28.5322C31.8349 29.7857 30.8188 30.8018 29.5654 30.8018H7.23799C5.98456 30.8018 4.96845 29.7857 4.96845 28.5322V25.2294H0V30.1022C0 33.0833 2.41668 35.5 5.39782 35.5H32.1048C35.0859 35.5 37.5026 33.0833 37.5026 30.1022V20.5024C37.5026 17.5213 35.0859 15.1046 32.1048 15.1046H7.238C5.98456 15.1046 4.96845 14.0885 4.96845 12.835V7.79556C4.96845 6.54212 5.98456 5.52601 7.23799 5.52601H29.6267C30.8463 5.52601 31.8349 6.51466 31.8349 7.73421Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.537 15.6145L203.927 15.0317L195.352 18.3824L197.156 20.9318L182.397 21.3689L191.378 17.9089L189.537 15.6145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a9b853fa4d9a9f69c642855b2b77d359.svg";
export { ForwardRef as ReactComponent };